<template>
  <v-row>
    <v-col cols="6">
      <!-- 仕入先名 -->
      <SelectSupplierName v-model="inputedValue.supplierName" cols="12" />
    </v-col>
    <v-col cols="6">
      <v-row no-gutters>
        <v-col cols="4" class="originalCenter">通貨 </v-col>
        <v-col cols="8">
          <!-- 通貨 -->
          <SelectCurrency v-model="inputedValue.currency" :clearable="true" />
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import {
  SelectSupplierName,
  SelectCurrency
} from '@/components/items/Selectboxes'

export default {
  components: {
    SelectSupplierName,
    SelectCurrency
  },
  props: {
    value: {}
  },
  data: () => ({
    items: []
  }),
  created() {
    //
  },
  computed: {
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  }
}
</script>
<style scoped lang="scss"></style>
